module.exports = __webpack_public_path__ + "static/img/最新技术@2x.e2f07ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/最新技术@2x.png
// module id = bO2C
// module chunks = 0